import { useEffect, useState } from "react";
export function useSearchDebounce(delay = 750) {
    const [search, setSearch] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    useEffect(() => {
        const delayFn = setTimeout(() => setSearch(searchQuery), delay);
        return () => clearTimeout(delayFn);
    }, [searchQuery, delay]);
    return { search, setSearchQuery };
}
export const usePageDebounce = (delay = 750) => {
    const [page, setPage] = useState(1);
    const [pageQuery, setPageQuery] = useState(1);
    useEffect(() => {
        const delayFn = setTimeout(() => setPage(pageQuery), delay);
        return () => clearTimeout(delayFn);
    }, [pageQuery, delay]);
    return { page, setPageQuery };
};
